import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/xian1.webp',
  './images/xian2.webp',
  './images/xian3.webp',
  './images/xian.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Xian, one of the oldest cities in China and the eastern terminus of the Silk Road, is renowned for its rich historical legacy and ancient architecture.

Top places to visit:

• Terracotta Army – A world-famous archaeological site with thousands of life-sized clay warriors guarding the tomb of Emperor Qin Shi Huang.
• Ancient City Wall – One of the oldest and best-preserved city walls in China, ideal for biking or walking tours.
• Big Wild Goose Pagoda – A sacred Buddhist site from the Tang Dynasty.
• Muslim Quarter – A bustling street market famous for street food and cultural fusion.
• Bell Tower – A historic symbol of Xi’an, beautifully lit at night.
• Shaanxi History Museum – A treasure trove of artifacts from ancient dynasties.
• Huaqing Palace – Scenic hot springs and historic royal gardens.
• Mount Huashan – A dramatic mountain offering adventurous hiking trails and stunning views.
• Forest of Stone Steles Museum – A collection of ancient stone inscriptions and calligraphy.
• Great Mosque of Xi’an – One of China’s oldest and most significant Islamic mosques.

Xi’an is a must-visit for history lovers, offering a deep dive into China’s imperial past and Silk Road heritage.`,

    zh: `西安是中国最古老的城市之一，也是古丝绸之路的东端，以其深厚的历史底蕴和壮丽的古代建筑而闻名。

推荐景点：

• 兵马俑 – 世界闻名的考古奇迹，成千上万的陶俑守护着秦始皇陵。
• 古城墙 – 中国现存最完整的古代城墙之一，适合骑行或漫步。
• 大雁塔 – 唐代佛教圣地，具有重要宗教意义。
• 回民街 – 热闹的美食街，融合了中西文化和回族风情。
• 钟楼 – 西安的标志性建筑，夜晚灯光璀璨。
• 陕西历史博物馆 – 收藏丰富的文物，展现千年古都风貌。
• 华清宫 – 风景优美的皇家园林和温泉胜地。
• 华山 – 壮观险峻的山峰，是登山爱好者的天堂。
• 碑林博物馆 – 收藏大量古代石刻和书法作品。
• 西安清真大寺 – 中国最古老的清真寺之一，融合中式与伊斯兰建筑风格。

西安是历史爱好者的天堂，让人穿越回中国辉煌的帝国时代和丝路起点的辉煌历史。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/xian1.webp" className="travel-image2" />
          <img src="./images/xian2.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Xian</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Xian</h2>
          <p className="carousel-subheading">
            Journey into China’s imperial heart — home of dynasties, warriors, and ancient trade.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc}  className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
